import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

import Empty from './Empty.jsx'

import CartItems from './CartItems.jsx'

const Cart = ({ cart, iScrollUpdate }) => {
    if (cart.items.length > 0) {
        //Позиции в корзине
        return <div className="happy-cart-small__items">
            <CartItems
                items={ cart.items }
                iScrollUpdate={ iScrollUpdate }
            />
        </div>
    } else {
        //Пустая корзина
        return <Empty />
    }
}

export default Cart